var map = {
	"./shbk_aftab.png": 5911,
	"./shbk_alborz.png": 6055,
	"./shbk_baran.png": 2227,
	"./shbk_booshehr.png": 1737,
	"./shbk_dena.png": 8483,
	"./shbk_fars.png": 8679,
	"./shbk_hamoon.png": 7027,
	"./shbk_isfahan.png": 6117,
	"./shbk_khalijefars.png": 83,
	"./shbk_khavaran.png": 9413,
	"./shbk_khuzestan.png": 3836,
	"./shbk_kurdestan.png": 5626,
	"./shbk_nkhorasan.png": 4124,
	"./shbk_qazvin.png": 9214,
	"./shbk_sabalan.png": 2789,
	"./shbk_sahand.png": 9738,
	"./shbk_semnan.png": 1733,
	"./shbk_taban.png": 6533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5951;